// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__9SpX+","success":"Badge_success__OMRxn","verifiedIcon":"Badge_verifiedIcon__ongPD"};